import { Component, ElementRef, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-gallery',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './gallery.html',
  styleUrls: ['./gallery.scss']
})
export class GalleryComponent implements AfterViewInit {
  @ViewChild('carousel', { static: true }) carousel!: ElementRef<HTMLDivElement>;

  images = Array.from({ length: 16 }, (_, i) => `/assets/images/${i + 1}.png`);

  private isDown = false;
  private startX = 0;
  private scrollLeftStart = 0;

  ngAfterViewInit() {
    const carousel = this.carousel.nativeElement;

    carousel.addEventListener('pointerdown', (e) => this.onPointerDown(e));
    carousel.addEventListener('pointermove', (e) => this.onPointerMove(e));
    carousel.addEventListener('pointerup', () => this.onPointerUp());
    carousel.addEventListener('pointerleave', () => this.onPointerUp());
  }

  onPointerDown(e: PointerEvent) {
    this.isDown = true;
    this.startX = e.clientX;
    this.scrollLeftStart = this.carousel.nativeElement.scrollLeft;
  }

  onPointerMove(e: PointerEvent) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.clientX;
    const walk = (x - this.startX) * 1.2; // velocidade do arrasto
    this.carousel.nativeElement.scrollLeft = this.scrollLeftStart - walk;
  }

  onPointerUp() {
    this.isDown = false;
  }

  trackByIndex(index: number): number {
    return index;
  }

  scrollLeft() {
    const carousel = this.carousel.nativeElement;
    const slideWidth = carousel.offsetWidth * 0.8;
    if (carousel.scrollLeft <= 0) {
      carousel.scrollTo({ left: carousel.scrollWidth, behavior: 'smooth' });
    } else {
      carousel.scrollBy({ left: -slideWidth, behavior: 'smooth' });
    }
  }

  scrollRight() {
    const carousel = this.carousel.nativeElement;
    const slideWidth = carousel.offsetWidth * 0.8;
    const maxScroll = carousel.scrollWidth - carousel.offsetWidth;
    if (carousel.scrollLeft >= maxScroll - 10) {
      carousel.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      carousel.scrollBy({ left: slideWidth, behavior: 'smooth' });
    }
  }
}
